'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _L10nMessage = require('@active/react-ui/shared/L10nMessage');

var _L10nMessage2 = _interopRequireDefault(_L10nMessage);

var _logoActiveNetworkGray = require('../images/logo-active-network-gray.svg');

var _logoActiveNetworkGray2 = _interopRequireDefault(_logoActiveNetworkGray);

require('./Footer.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var currentYear = new Date().getUTCFullYear();
  return _react2.default.createElement(
    'div',
    { className: 'app-footer' },
    _react2.default.createElement(
      'div',
      { className: 'app-footer__item' },
      _react2.default.createElement(
        'a',
        { className: 'app-footer__logo', href: 'http://www.activenetwork.com' },
        _react2.default.createElement('img', { src: _logoActiveNetworkGray2.default, alt: '' })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'app-footer__links' },
      _react2.default.createElement(
        'div',
        { className: 'app-footer__link' },
        _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: 'http://www.active.com/page/about/' },
          _react2.default.createElement(_L10nMessage2.default, { id: 'core.comp.footer.about' })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'app-footer__link' },
        _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: 'http://www.activenetwork.com/information/terms-of-use' },
          _react2.default.createElement(_L10nMessage2.default, { id: 'core.comp.footer.terms' })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'app-footer__link' },
        _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: ' http://www.activenetwork.com/information/copyright-policy' },
          _react2.default.createElement(_L10nMessage2.default, { id: 'core.comp.footer.copyrightPolicy' })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'app-footer__link' },
        _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: 'http://www.activenetwork.com/information/privacy-policy' },
          _react2.default.createElement(_L10nMessage2.default, { id: 'core.comp.footer.privacy' })
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'app-footer__item' },
      _react2.default.createElement(
        'a',
        { href: 'http://www.activenetwork.com/', className: 'copyright-color' },
        _react2.default.createElement(
          'span',
          null,
          '\xA9\xA0'
        ),
        _react2.default.createElement(
          'span',
          { id: 'copyYear' },
          currentYear
        ),
        _react2.default.createElement(
          'span',
          null,
          '\xA0',
          _react2.default.createElement(_L10nMessage2.default, { id: 'core.comp.footer.copyright' })
        )
      )
    )
  );
};